import React from 'react';
import { ImpactEvaluationTable, TrainingCompletedModal } from './components';
import { ImpactEvaluationTableProps } from './types';
import './style.scss';

/**
 * Componente principal para exibição de avaliações de impacto
 * 
 * @param userId - ID do usuário para buscar suas avaliações
 */
const ImpactEvaluation: React.FC<ImpactEvaluationTableProps> = ({ userId, rawEvaluations, loadingEvaluations }) => {
  return (
    <div className="ptcHistory">
      <div className="responsiveTableWrapper">
        <div className="impact-evaluation-table">
          <ImpactEvaluationTable userId={userId} rawEvaluations={rawEvaluations} loadingEvaluations={loadingEvaluations} />
        </div>
      </div> 
    </div>
  );
};

export default ImpactEvaluation;